const LISTE_LIGNES_DEVIS = {
  title: 'Liste des lignes de devis',
  tabs: {
    planMedia: 'N° Plan media',
    codeDevis: 'N° Devis',
    produit: 'Produit',
    dateDeDevis: 'Date devis',
    commercial: 'Commercial',
    clients: 'Client(s)',
    etat: 'Etat devis.',
    sousType: 'Type',
    dateCampagne: 'Date campagne',
    dateDebut: 'Date début ligne',
    dateFin: 'Date fin ligne',
    codeDossier: 'Code dossier',
    montantHt: 'Mnt HT devis.',
    totalHt: 'Total HT ligne',
    typeProduit: 'Type de produit',
    patrimoine: 'Patrimoine(s)',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    datePremierAffichage: 'Date de campagne',
    dateDevis: 'Date devis',
    au: 'au',
    clients: 'Clients',
    codePM: 'N° Plan media',
    code: 'N° Devis',
    etat: 'Liste des états',
    commercial: 'Commercial',
    referenceClient: 'Référence client',
    agence: 'Agence(s)',
    codeDossier: 'Code(s) dossier',
    fournisseur: 'Fournisseur(s)',
    assistant: 'Assistant',
    sansAssistant: 'Sans assistant',
    noCommercial: 'Sans commercial',
    libelleProduit: 'Libellé produit',
    produits: 'Produits',
    patrimoine: 'Patrimoine(s)',
    typePatrimoine: 'Type(s) de patrimoine',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
  },
};

export default LISTE_LIGNES_DEVIS;
